<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                    <b-row>
                        <b-col xl="12" lg="12" sm="12">
                            <ValidationObserver ref="form1"  v-slot="{ handleSubmit, reset }">
                                <b-form @submit.prevent="handleSubmit(addRoutine)" @reset.prevent="reset">
                                    <b-row>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Fiscal Year" vid="fiscal_year" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="fiscal_year_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.fiscal_year')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="dataArray.fiscal_year_id"
                                                    id="fiscal_year_id"
                                                    :options="fiscalYearList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Organization Name" vid="org_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="org_id "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('institute_manangement.organization_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="dataArray.org_id"
                                                    id="org_id"
                                                    :options="orgList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Institute Type" vid="institute_type_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="institute_type_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('institute_manangement.institute_type')}}  <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="dataArray.office_type_id"
                                                    id="institute_type_id"
                                                    :options="officeTypeList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                             <ValidationProvider name="Institute Name" vid="institute_name" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="institute_name_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('institute_manangement.institute_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="dataArray.office_id"
                                                    id="institute_name_id"
                                                    :options="officeList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col xl="6" lg="6" sm="12">
                                            <ValidationProvider name="School Name" vid="school_id" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="school_id"
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <template v-slot:label>
                                                        {{$t('child_admission_management.school_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                        plain
                                                        v-model="dataArray.school_id"
                                                        id="school_id"
                                                        :options="schoolList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                             <ValidationProvider name="Class" vid="class_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="class_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.class')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="dataArray.class_id"
                                                    id="class_id"
                                                    :options="classList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <hr style="bg-color:green">
                                    <b-overlay :show="unitLoad">
                                    <b-row>
                                        <b-col lg="6" sm="12">
                                           <ValidationProvider name="Course Name" vid="course_name" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="course_name_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.course_name')}}  <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="detailsFormData.course_id"
                                                    id="course_name_id"
                                                    :options="courseList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Instructor Name" vid="instructor_id" rules="required|min_value:1">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="instructor_id "
                                                    slot-scope="{ valid, errors }"
                                                >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.instructor_name')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-select
                                                    plain
                                                    v-model="detailsFormData.instructor_id"
                                                    id="instructor_id"
                                                    :options="instructorList"
                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                    >
                                                    <template v-slot:first>
                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                    </template>
                                                    </b-form-select>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                         <b-col lg="6" sm="12">
                                           <ValidationProvider name="Date" vid="date_id" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="date_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.date')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <flat-pickr class="form-control"
                                                        id="date_id"
                                                      v-model="detailsFormData.routine_date"
                                                      :placeholder="$t('globalTrans.select_date')"
                                                      :state="errors[0] ? false : (valid ? true : null)"
                                                    ></flat-pickr>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col lg="6" sm="12">
                                            <ValidationProvider name="Start Time" vid="start_time" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="start_time "
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.start_time')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                      id="start_time_id"
                                                      type="time"
                                                      v-model="detailsFormData.start_time"
                                                      :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                         <b-col lg="6" sm="12">
                                           <ValidationProvider name="End Time" vid="end_time" rules="required">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="5"
                                                    label-for="end_time_id"
                                                    slot-scope="{ valid, errors }"
                                                    >
                                                    <template v-slot:label>
                                                    {{$t('educational_management.end_time')}} <span class="text-danger">*</span>
                                                    </template>
                                                    <b-form-input
                                                      id="end_time_id"
                                                      type="time"
                                                      v-model="detailsFormData.end_time"
                                                      :state="errors[0] ? false : (valid ? true : null)"
                                                    ></b-form-input>
                                                    <div class="invalid-feedback">
                                                    {{ errors[0] }}
                                                    </div>
                                                </b-form-group>
                                            </ValidationProvider>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                    <b-col xl="6" lg="6" sm="12">
                                        <ValidationProvider name="Remarks (En)" vid='remarks'>
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="remark_en"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('institute_manangement.remarks')}}
                                                </template>
                                                <b-form-textarea
                                                id="remark_en"
                                                v-model="detailsFormData.remark"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                 rows="2"
                                                max-rows="6"
                                                ></b-form-textarea>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    <b-col xl="6" lg="6" sm="12">
                                        <ValidationProvider name="Remarks (Bn)" vid='remarks_bn'>
                                            <b-form-group
                                                class="row"
                                                label-cols-sm="5"
                                                label-for="remarks_bn"
                                                slot-scope="{ valid, errors }"
                                            >
                                                <template v-slot:label>
                                                {{ $t('institute_manangement.remarks_bn')}}
                                                </template>
                                                <b-form-textarea
                                                id="remarks_bn"
                                                v-model="detailsFormData.remark_bn"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                                 rows="2"
                                                max-rows="6"
                                                ></b-form-textarea>
                                                <div class="invalid-feedback">
                                                {{ errors[0] }}
                                                </div>
                                            </b-form-group>
                                        </ValidationProvider>
                                    </b-col>
                                    </b-row>
                                    </b-overlay>
                                    <div class="row" v-if="add">
                                        <div class="col-sm-3"></div>
                                            <div class="col text-right">
                                            <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.add') }}</b-button>
                                        </div>
                                    </div>
                                </b-form>
                            </ValidationObserver>
                            <br/>
                            <!-- start add more  -->
                            <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset">
                                   <b-row v-if="add">
                                            <table class="table table-bordered">
                                                <thead class="text-white" style="background-color: #577399">
                                                    <tr style="background-color: #577399">
                                                        <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                                        <th>{{ $t('educational_management.course_name') }}</th>
                                                        <th>{{ $t('educational_management.course_teacher') }}</th>
                                                        <th>{{ $t('educational_management.start_time') }}</th>
                                                        <th>{{ $t('educational_management.end_time') }}</th>
                                                        <th>{{ $t('globalTrans.action') }}</th>
                                                    </tr>
                                                </thead>
                                                <b-tr v-for="(item, index) in dataArray.details" :key="index">
                                                    <td>{{ $n(index + 1) }}</td>
                                                    <b-td>
                                                        <ValidationProvider name="Course Name" vid="course_name" rules="required|min_value:1">
                                                            <b-form-group
                                                                style="margin-bottom: 0rem"
                                                                slot-scope="{ valid, errors }"
                                                                >
                                                                <b-form-select
                                                                plain
                                                                v-model="item.course_id"
                                                                id="course_name"
                                                                :options="courseList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                                >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                                </b-form-select>
                                                                <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-td>
                                                    <b-td>
                                                        <ValidationProvider name="Instructor Name" vid="instructor_id" rules="required|min_value:1">
                                                            <b-form-group
                                                                style="margin-bottom: 0rem"
                                                                slot-scope="{ valid, errors }"
                                                            >
                                                                <b-form-select
                                                                    plain
                                                                    v-model="item.instructor_id"
                                                                    id="instructor_id"
                                                                    :options="instructList"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                >
                                                                    <template v-slot:first>
                                                                        <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                                    </template>
                                                                </b-form-select>
                                                                <div class="invalid-feedback">
                                                                    {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-td>
                                                    <b-td>
                                                        <ValidationProvider name="Start Time" vid="start_time_id" rules="required">
                                                            <b-form-group
                                                                style="margin-bottom: 0rem"
                                                                slot-scope="{ valid, errors }"
                                                            >
                                                                <b-form-input
                                                                    id="start_time_id"
                                                                    type="time"
                                                                    v-model="item.start_time"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                </b-form-input>
                                                                <div class="invalid-feedback">
                                                                    {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-td>
                                                    <b-td>
                                                        <ValidationProvider name="End Time" vid="end_time_id" rules="required">
                                                            <b-form-group
                                                                style="margin-bottom: 0rem"
                                                                slot-scope="{ valid, errors }"
                                                            >
                                                                <b-form-input
                                                                    id="end_time_id"
                                                                    type="time"
                                                                    v-model="item.end_time"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    >
                                                                </b-form-input>
                                                                <div class="invalid-feedback">
                                                                    {{ errors[0] }}
                                                                </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-td>
                                                    <b-td>
                                                        <button type="button" @click="deleteItem(index)" class="btn btn- iq-bg-danger btn-sm"><i class="ri-delete-bin-line m-0"></i></button>
                                                    </b-td>
                                                </b-tr>
                                            </table>
                                    </b-row>
                                    <br>
                                    <div class="row">
                                        <div class="col-sm-3"></div>
                                        <div class="col text-right">
                                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                            &nbsp;
                                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                        </div>
                                    </div>
                                </b-form>
                            </ValidationObserver>
                            <!-- end add more  -->
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '../../../../../config/api_config'
import { routineSaveApi, routineUpdateApi, instructorInfoApi } from '../../api/routes'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        if (this.id) {
            const tmp = this.getRoutineData()
            this.dataArray = tmp
        }
        this.dataArray.org_id = this.$store.state.dataFilters.orgId
        this.dataArray.office_type_id = this.$store.state.dataFilters.officeTypeId
        this.dataArray.office_id = this.$store.state.dataFilters.officeId
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            dataArray: {
                fiscal_year_id: 0,
                org_id: 0,
                office_type_id: 0,
                office_id: 0,
                school_id: 0,
                class_id: 0,
                details: []
            },
            detailsFormData: {
                course_id: 0,
                routine_date: '',
                start_time: '',
                end_time: '',
                instructor_id: 0,
                remark: '',
                remark_bn: ''
            },
            add: true,
            officeTypeList: [],
            officeList: [],
            courseList: [],
            schoolList: [],
            instructorList: [],
            loading: false,
            unitLoad: false
        }
    },
    computed: {
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        },
        classList: function () {
            return this.$store.state.ChildService.commonObj.classList.filter(item => item.status === 1)
        },
        instructList: function () {
            return this.$store.state.ChildService.commonObj.instructorList.filter(item => item.status === 1)
        },
        currentLocale () {
            return this.$i18n.locale
        },
        ...mapGetters({
            childCommonObj: 'ChildService/commonObj'
        })
    },
    watch: {
        'dataArray.org_id': function (newVal) {
            this.officeTypeList = this.getofficeTypeList(newVal)
        },
        'dataArray.office_type_id': function (newVal) {
            this.officeList = this.getOfficeList(newVal)
        },
        'dataArray.class_id': function (newVal) {
            this.courseList = this.getCourseByClass(newVal)
        },
        'dataArray.office_id': function (newVal) {
            this.schoolList = this.getSchoolList(newVal)
        },
        'detailsFormData.course_id': function (newVal, oldVal) {
            if (newVal !== oldVal && newVal !== 0) {
                this.loadInstructorData(newVal)
            }
        }
    },
    methods: {
        loadInstructorData (courseId) {
            this.unitLoad = true
            const search = {
                fiscal_year_id: this.dataArray.fiscal_year_id,
                org_id: this.dataArray.org_id,
                office_type_id: this.dataArray.office_type_id,
                office_id: this.dataArray.office_id,
                class_id: this.dataArray.class_id,
                course_id: courseId
            }
            RestApi.getData(childServiceBaseUrl, instructorInfoApi, search).then(response => {
                if (response.success) {
                    this.instructorList = response.data.map(item => {
                        const tmp = this.$i18n.locale === 'en' ? { text: item.name } : { text: item.name_bn }
                        return Object.assign({}, item, tmp)
                    })
                    this.unitLoad = false
                }
            })
        },
        deleteItem (index) {
            this.dataArray.details.splice(index, 1)
        },
        addRoutine () {
            const tmp = JSON.parse(JSON.stringify(this.detailsFormData))
            this.dataArray.details.push(tmp)
            // reset field
            this.detailsFormData.course_id = 0
            this.detailsFormData.routine_date = ''
            this.detailsFormData.start_time = ''
            this.detailsFormData.end_time = ''
            this.detailsFormData.instructor_id = 0
            this.detailsFormData.remark = ''
            this.detailsFormData.remark_bn = ''
            this.$nextTick(() => {
                this.$refs.form1.reset()
            })
        },
        async saveData () {
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadingState = { loading: false, listReload: false }
            if (this.id) {
                result = await RestApi.putData(childServiceBaseUrl, `${routineUpdateApi}/${this.id}`, this.dataArray)
            } else {
                result = await RestApi.postData(childServiceBaseUrl, routineSaveApi, this.dataArray)
            }
            loadingState.listReload = true
            this.$store.dispatch('mutateCommonProperties', loadingState)
            if (result.success) {
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else if (result.code === 403) {
                this.$toast.error({
                    title: this.$t('globalTrans.error'),
                    message: this.$t('educational_management.already_assigned'),
                    color: '#D6E09B'
                })
            } else {
                this.$refs.form.setErrors(result.errors)
            }
        },
        getRoutineData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getofficeTypeList (orgId = null) {
            const instituteTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value))
            if (orgId) {
                return instituteTypeList.filter(institute => institute.org_id === orgId)
            }
            return instituteTypeList
        },
        getOfficeList (typeId = null) {
            const instituteList = this.$store.state.commonObj.officeList.filter(item => item.status === 0)
            if (typeId) {
                return instituteList.filter(institute => institute.office_type_id === typeId)
            }
            return instituteList
        },
        getSchoolList (typeId) {
            return this.$store.state.ChildService.commonObj.schoolList.filter(item => item.status === 1 && item.office_id === typeId)
        },
        getCourseByClass (classId) {
            return this.$store.state.ChildService.commonObj.courseList.filter(item => item.status === 1 && item.class === classId)
        }
    }
}

</script>
